import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import DateInput from '../common/DateInput';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { driversApi, exportApi } from '../../api/services';
import { useAlerts } from '../../custom/Alerts';
import { addDays, monthRangeLabel, startOfToday } from '../../utils/dates';
import { driverLabel } from '../../utils/activities';
import { blobError, download, useReportStatus } from './reportUtils';
import { ReportFooter, ReportProgress } from './ReportForm';

/* Potvrda o aktivnostima: 1) "Proveri pauze" (pauze duže od 45 h), 2) generisanje PDF potvrda (zip). */
export default function AttestationForm({ onClose }) {
    const alerts = useAlerts();
    const status = useReportStatus();
    const [drivers, setDrivers] = useState([]);
    const [driver, setDriver] = useState(null);
    const [from, setFrom] = useState(addDays(startOfToday(), -7));
    const [to, setTo] = useState(startOfToday());
    const [breaks, setBreaks] = useState(null);
    const [checking, setChecking] = useState(false);

    useEffect(() => {
        driversApi.all({ companyIds: [] }).then((r) => { setDrivers(r.drivers); setDriver(r.drivers[0] || null); }).catch(() => {});
    }, []);

    const check = async () => {
        setChecking(true);
        try {
            const res = await exportApi.detectAttestation({ driverId: driver.id, startDate: from, endDate: to });
            setBreaks(res);
        } catch { /* toast */ }
        setChecking(false);
    };

    const setActivity = (di, ai, patch) => setBreaks((b) => ({
        ...b,
        drivers: b.drivers.map((d, i) => (i !== di ? d : { ...d, activities: d.activities.map((a, j) => (j !== ai ? a : { ...a, ...patch })) })),
    }));

    const generate = async () => {
        status.start();
        try {
            const res = await exportApi.attestation(breaks);
            const d = breaks.drivers[0];
            download(res, `Potvrda o aktivnostima - ${d.firstName} ${d.lastName} - ${monthRangeLabel(from, to)}.zip`);
            status.done();
        } catch (e) {
            status.fail();
            alerts.error(await blobError(e));
        }
    };

    const datesOk = from && to;
    return (
        <Dialog visible header="Potvrda o aktivnostima" onHide={onClose} style={{ width: '56rem', maxWidth: '96vw' }} modal
            footer={<ReportFooter onClose={onClose} onGenerate={generate} busy={status.state.busy}
                disabled={!breaks || !datesOk || checking || status.state.busy} />}>
            <p className="form-hint">Prvo proverite pauze duže od 45 sati, označite one za koje se izdaje potvrda, pa generišite izveštaj.</p>
            <div className="filters">
                <div className="field grow"><label htmlFor="at-driver">Vozač</label>
                    <Dropdown inputId="at-driver" value={driver} options={drivers.map((d) => ({ label: driverLabel(d), value: d }))} dataKey="id" filter
                        virtualScrollerOptions={drivers.length > 10 ? { itemSize: 40 } : undefined} onChange={(e) => { setDriver(e.value); setBreaks(null); }} /></div>
                <div className="field date"><label htmlFor="at-from">Od</label>
                    <DateInput inputId="at-from" value={from} onChange={(e) => { setFrom(e.value); setBreaks(null); }} dateFormat="dd.mm.yy" showIcon /></div>
                <div className="field date"><label htmlFor="at-to">Do</label>
                    <DateInput inputId="at-to" value={to} onChange={(e) => { setTo(e.value); setBreaks(null); }} dateFormat="dd.mm.yy" showIcon /></div>
                <div className="filters-actions">
                    <Button label="Proveri pauze" icon="pi pi-search" severity="secondary" onClick={check} disabled={!datesOk || !driver || checking} loading={checking} /></div>
            </div>

            {breaks && (
                <div style={{ marginTop: '1.25rem' }}>
                    {breaks.drivers.every((d) => !d.activities.length) && <div className="callout info"><i className="pi pi-info-circle" aria-hidden="true" />Nema pauza dužih od 45 sati za izabrani period.</div>}
                    <Accordion activeIndex={0}>
                        {breaks.drivers.map((d, di) => (
                            <AccordionTab key={d.driverId} header={`${d.lastName} ${d.firstName} - ${d.uniqueId} - ${d.companyName || ''}`}>
                                <table className="attest-table">
                                    <thead><tr><th>Vreme početka</th><th>Vreme završetka</th><th>Obradi</th></tr></thead>
                                    <tbody>
                                        {d.activities.map((a, ai) => (
                                            <tr key={ai}>
                                                <td><DateInput value={a.startDate} onChange={(e) => setActivity(di, ai, { startDate: e.value })}
                                                    showTime hourFormat="24" dateFormat="dd.mm.yy" appendTo={document.body} /></td>
                                                <td><DateInput value={a.endDate} onChange={(e) => setActivity(di, ai, { endDate: e.value })}
                                                    showTime hourFormat="24" dateFormat="dd.mm.yy" appendTo={document.body} /></td>
                                                <td><Checkbox aria-label="Obradi pauzu" checked={!!a.shouldProcess} onChange={(e) => setActivity(di, ai, { shouldProcess: e.checked })} /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </AccordionTab>
                        ))}
                    </Accordion>
                </div>
            )}
            <ReportProgress status={status.state} />
        </Dialog>
    );
}
